import React, {useState} from "react";
import {FaChevronDown, FaLock} from "react-icons/fa";
import {t} from "i18next";
import {EmergencyContact} from "../../models/emergencyContact";
import EmergencyContactView from "./EmergencyContactView";
import ViewLocked from "../components/ViewLocked";

interface EmergencyContactsViewProps {
    emergencyContacts: EmergencyContact[];
}

function EmergencyContactsView({emergencyContacts}: EmergencyContactsViewProps) {
    const [open, setOpen] = useState(false);

    // 🔒 Keine Daten freigegeben
    if (emergencyContacts.length === 0) {
        <ViewLocked message={t("common.messages.noSharedData")}/>
    }

    return (
        <div className="view-container">
            {/* Header */}
            <div className="view-header" onClick={() => setOpen(!open)}>
                <div className="view-header-spacer"/>
                <h3 className="view-title">{t("menu.emergency")}</h3>
                <FaChevronDown className={`view-arrow ${open ? "open" : ""}`}/>
            </div>

            {/* Inhalt */}
            {open && (
                <div className="view-content">

                    {emergencyContacts.map((e) => (
                        <EmergencyContactView emergencyContact={e}/>
                    ))}
                </div>
            )}
        </div>
    );
}

export default EmergencyContactsView;